import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./css/ui/Modal.scss";
import "./css/ui/Table.scss";
import "./index.scss";
import reportWebVitals from './reportWebVitals';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

reportWebVitals();
